module.exports = __webpack_public_path__ + "img/it_seguromultidispositivo.5eebcac4.svg";